import * as THREE from "three";
import type { CrownSolveResult } from "../../../types/restoration";

export function buildCrownOverlayMesh(
  result: CrownSolveResult
): THREE.Object3D | null {
  if (!result.success) {
    return null;
  }

  const [cx, cy, cz] = result.center;
  const [w, h, d] = result.dimensions;
  const [rx, ry, rz] = result.rotationEuler;

  const crownGeometry = new THREE.BoxGeometry(w, h, d);

  const crownMaterial = new THREE.MeshStandardMaterial({
    color: 0x22d3ee,
    transparent: true,
    opacity: 0.6,
    emissive: 0x0891b2,
    emissiveIntensity: 0.25,
  });

  const crownMesh = new THREE.Mesh(crownGeometry, crownMaterial);
  crownMesh.position.set(cx, cy, cz);
  crownMesh.rotation.set(rx, ry, rz);

  crownMesh.userData.kind = "restoration";
  crownMesh.userData.restorationType = "crown";
  crownMesh.userData.isGenerated = true;

  return crownMesh;
}